var map = {
	"./books": 3733,
	"./books.js": 3733,
	"./calendars": 6255,
	"./calendars.js": 6255,
	"./discounts": 6535,
	"./discounts.js": 6535,
	"./galleries": 8047,
	"./galleries.js": 8047,
	"./groups": 9072,
	"./groups.js": 9072,
	"./magnets": 8352,
	"./magnets.js": 8352,
	"./orders": 6510,
	"./orders.js": 6510,
	"./packages": 1566,
	"./packages.js": 1566,
	"./processings": 823,
	"./processings.js": 823,
	"./sizes": 8496,
	"./sizes.js": 8496,
	"./users": 5375,
	"./users.js": 5375,
	"./watermarks": 6085,
	"./watermarks.js": 6085
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7514;